import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// The care plan is a per-review artifact (KIN-1193/1194). Fetch by reviewId via
// the review-scoped endpoint; the patient-scoped route is deprecated.
export const useGetCarePlan = (reviewId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["reviewCarePlan", reviewId, tenantVal],
    queryFn: async () => {
      if (!reviewId) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/cdm/reviews/${reviewId}/care-plan`
      );

      // CdmController uses the legacy envelope — the body IS the CarePlanView,
      // there is no { status, data } wrapper to unwrap.
      return response.data;
    },
    enabled: !!reviewId && !!tenantVal,
  });
};
